import PannellumView from './pannellum-view'

export default PannellumView
